import { memo, useState } from "react";
import Button from "../../../../../../common/components/xepp/button/Button";
import styles from "./SelectDepartmentModal.module.scss";
import { Department } from "../../../../../../model/departments/department";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: (departmentId: string) => void;
	departments: Department[];
};

const SelectDepartmentModal = memo(({ isOpen, onClose, onConfirm, departments }: Props) => {
	const [selectedDepartmentId, setSelectedDepartmentId] = useState<string | null>(null);

	const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget) onClose();
	};

	const handleConfirm = () => {
		if (!selectedDepartmentId) return;
		onConfirm(selectedDepartmentId);
		setSelectedDepartmentId(null);
	};

	const handleClose = () => {
		setSelectedDepartmentId(null);
		onClose();
	};

	if (!isOpen) return null;

	return (
		<div className={styles.backdrop} onClick={handleBackdropClick}>
			<div className={styles.modal}>
				<div className={styles.header}>
					<h2 className={styles.title}>Route to Next Department</h2>
					<p className={styles.subtitle}>Please select a department from the list below</p>
				</div>

				<div className={styles.departmentList}>
					{departments.map(dept => (
						<div
							key={dept.id}
							className={`${styles.departmentItem} ${selectedDepartmentId === dept.id ? styles.selected : ""}`}
							onClick={() => setSelectedDepartmentId(dept.id)}
						>
							<span className={styles.departmentName}>{dept.name}</span>
							{selectedDepartmentId === dept.id && <span className={styles.checkmark}>✓</span>}
						</div>
					))}
				</div>

				<div className={styles.actions}>
					<Button text="Cancel" variant="outline" onClick={handleClose} />
					<Button text="Save" variant="secondary" onClick={handleConfirm} disabled={!selectedDepartmentId} />
				</div>
			</div>
		</div>
	);
});

export default SelectDepartmentModal;
